module.exports = __webpack_public_path__ + "images/emoji/heartpulse.913f58291b8cf038cde0.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/heartpulse.png
// module id = I70i
// module chunks = 2